import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './routers'
import i18n from './i18n'
import VueTheMask from 'vue-the-mask'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'

export const app = createApp(App)
    .use(Quasar, quasarUserOptions)
    .use(i18n)
    .use(router)
    .use(store)    
    .use(VueTheMask)
    .mount('#app')